import { useTranslation } from 'react-i18next';
import { Chip, Popover } from '@c2fo/liquidity';
import { RabbitRunningIcon } from '@c2fo/liquidity/icons';
import { INSTANT_PAY_FUNDING_PARTNER } from './instantPayFundingPartner';

interface InstantPayStatusChipProps {
  /** Turn off inside an interactive element (a link row), where clicking must reach the parent. */
  withTooltip?: boolean;
}

const InstantPayStatusChip = ({ withTooltip = true }: InstantPayStatusChipProps) => {
  const { t } = useTranslation();

  const chip = (
    <Chip
      className="border-teal-500 bg-teal-50 text-teal-900 [&>svg]:fill-teal-900"
      size="xs"
      label={t('core.history.statusAwarded')}
      isRound
      startIcon={{ icon: RabbitRunningIcon, name: t('core.instantPay') }}
      variant="outlined"
    />
  );

  if (!withTooltip) {
    return chip;
  }

  return (
    <Popover>
      <Popover.Trigger>{chip}</Popover.Trigger>
      <Popover.Content arrow side="right">
        <div className="w-52 text-center text-sm">
          {t('instantPay.history.statusAwardedTooltip', { fundingPartner: INSTANT_PAY_FUNDING_PARTNER })}
        </div>
      </Popover.Content>
    </Popover>
  );
};

export default InstantPayStatusChip;
